export default __webpack_public_path__ + "static/icon-25-1-40b2c8c69825cce1ae80c55e9b489fa3.png";